var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('ha-page-loader'),_c('ha-site-menu'),_c('router-view'),_c('ha-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }